import { ReactNode, useState, useEffect } from 'react'
import Sidebar from './Sidebar'
import Header from './Header'
import Footer from './Footer'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)

  // Load sidebar state from localStorage
  useEffect(() => {
    const saved = localStorage.getItem('sidebarCollapsed')
    if (saved) {
      setSidebarCollapsed(JSON.parse(saved))
    }
  }, [])

  // Handle sidebar toggle
  const handleToggleSidebar = () => {
    const newState = !sidebarCollapsed
    setSidebarCollapsed(newState)
    localStorage.setItem('sidebarCollapsed', JSON.stringify(newState))
  }

  return (
    <div className="h-screen flex flex-col overflow-hidden relative">
      {/* Fixed background gradient */}
      <div
        className="fixed inset-0 -z-10"
        style={{ background: 'linear-gradient(90deg, rgba(91, 152, 186, 1) 0%, rgba(244, 246, 252, 1) 45%, rgba(255, 255, 255, 1) 100%)' }}
      />

      <Header
        sidebarCollapsed={sidebarCollapsed}
        onToggleSidebar={handleToggleSidebar}
      />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar
          collapsed={sidebarCollapsed}
        />
        <main className="flex-1 overflow-y-auto relative">
          {/* Sticky semi-transparent overlay - set to z-0 to stay behind content */}
          <div className="sticky top-0 left-0 right-0 h-screen bg-primary-50/80 backdrop-blur-xl pointer-events-none -mb-[100vh] z-0" />

          {/* Content wrapper - provides padding but not positioning context */}
          <div className="p-4 relative z-10 min-h-full">
            <div className="max-w-full mx-auto">
              {children}
            </div>
          </div>

          {/* Footer - appears at the bottom after scrolling */}
          <Footer />
        </main>
      </div>
    </div>
  )
}
